import { ConfigCreateHTHTerritoriesMap } from './ConfigCreateHTHTerritoriesMap';
import { Container, FloatingLabel, Form } from 'react-bootstrap';
import { Dispatch, FC, SetStateAction, useState } from 'react';
import { H2 } from 'src/components/_commons';
import { hideLoadingModalReducer, setAlertResponse, setValuesAndOpenAlertModalReducer, showLoadingModalReducer } from 'src/store';
import { houseToHouseServices } from 'src/services';
import { useDispatch } from 'react-redux';

type propsType = {
    setShowCreateHthTerritories: Dispatch<SetStateAction<boolean>>;
};

export const ConfigCreateHTHTerritories: FC<propsType> = ({ setShowCreateHthTerritories }) => {
    const [map, setMap] = useState<google.maps.Map | null>(null);
    const [numberOfTerritories, setNumberOfTerritories] = useState(0);
    const dispatch = useDispatch();

    const createHthTerritoriesHandler = async () => {
        const centerLat = map?.getCenter()?.lat();
        const centerLng = map?.getCenter()?.lng();
        if (!numberOfTerritories || !Number.isInteger(numberOfTerritories) || !centerLat || !centerLng) {
            return;
        }
        if (numberOfTerritories > 200) {
            dispatch(setValuesAndOpenAlertModalReducer({
                mode: 'alert',
                title: 'Error',
                message: 'Se permiten hasta 200 territorios',
                animation: 2
            }));
            return;
        }
        dispatch(setValuesAndOpenAlertModalReducer({
            mode: 'confirm',
            title: 'Crear territorios',
            message: `Se van a crear ${numberOfTerritories} territorios para casa en casa y el punto central inicial va a ser latitud ${centerLat}, longitud ${centerLng}`,
            execution: async () => {
                dispatch(showLoadingModalReducer());
                const response = await houseToHouseServices.CreateTerritories(numberOfTerritories, centerLat, centerLng);
                dispatch(hideLoadingModalReducer());
                if (!response.success) {
                    dispatch(setAlertResponse({ response }));
                    return;
                }
                window.location.reload();
            }
        }));
    }

    return (
        <Container>
            <H2 title={'CREAR LOS TERRITORIOS PARA CASA EN CASA'} />
            <Container className={'maxw-400'}>
                <FloatingLabel className={'mt-5 mb-4 text-dark'}
                    label={"Elegir la cantidad de territorios"}
                >
                    <Form.Control type={'number'}
                        className={'form-control'}
                        placeholder={''}
                        value={numberOfTerritories || ''}
                        onChange={e => setNumberOfTerritories(parseInt(e.target.value))}
                        autoFocus
                    />
                </FloatingLabel>
            </Container>
            {!!numberOfTerritories &&
                <>
                <ConfigCreateHTHTerritoriesMap
                    setMap={setMap}
                />
                <Container className={'maxw-400'}>
                    <button className={'btn btn-general-blue d-block w-100 mt-5'}
                        style={{ fontWeight: 'bolder', height: '50px' }}
                        onClick={createHthTerritoriesHandler}
                    >
                        Aceptar
                    </button>
                    <button className={'btn btn-general-red d-block w-100 mt-3'}
                        style={{ fontWeight: 'bolder', height: '50px' }}
                        onClick={() => setShowCreateHthTerritories(false)}
                    >
                        Cancelar
                    </button>
                </Container>
                </>
            }
        </Container>
    );
}
